import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'

import './assets/css/main.css'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import axios from './axios'
Vue.prototype.$axios = axios

import getMenu from './utils/getMenu'
Vue.prototype.$getMenu = getMenu

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/utils/drag.js'

Vue.use(ElementUI, {
  size: 'small'
})

Vue.config.productionTip = false

new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')
